function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0999 5.9499L17.0999 5.1999C17.3517 5.01105 17.4999 4.71466 17.4999 4.3999V2.3999C17.4999 1.84762 17.0522 1.3999 16.4999 1.3999H11.4999C10.9476 1.3999 10.4999 1.84762 10.4999 2.3999V4.3999C10.4999 4.71466 10.6481 5.01105 10.8999 5.1999L11.8999 5.9499M16.0999 5.9499V6.67944C16.0999 6.88786 16.165 7.09108 16.2862 7.26068L18.8548 10.8568C19.3394 11.5352 19.5999 12.3481 19.5999 13.1818V25.5999C19.5999 26.1522 19.1522 26.5999 18.5999 26.5999H9.3999C8.84762 26.5999 8.3999 26.1522 8.3999 25.5999L8.3999 13.1818C8.3999 12.3481 8.6604 11.5352 9.14497 10.8568L11.7136 7.26068C11.8348 7.09108 11.8999 6.88786 11.8999 6.67944V5.9499M16.0999 5.9499H11.8999",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8 18.2001C16.8 19.7465 15.5463 21.0001 14 21.0001C12.4536 21.0001 11.2 19.7465 11.2 18.2001C11.2 16.6537 14 12.6001 14 12.6001C14 12.6001 16.8 16.6537 16.8 18.2001Z",
  stroke: "white",
  strokeWidth: 2
});

var SvgWater = function SvgWater(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWater, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/water.156892d7.svg";
export { ForwardRef as ReactComponent };